"use client";

import { useAbility } from "@/hooks/useAbility";

export type TeamSettingsPath = "/settings/team-settings/general" | "/settings/team-settings/users";

export interface TeamSettingsAccess {
  isLoading: boolean;
  canEditTeamSettings: boolean;
  canViewUsers: boolean;
  hasAnyAccess: boolean;
  firstAccessiblePath: TeamSettingsPath | null;
}

export function useTeamSettingsAccess(teamScopeId?: string): TeamSettingsAccess {
  const { can, isLoading } = useAbility();

  const canEditTeamSettings = can("editTeamSettings", { scopeType: "TEAM", scopeId: teamScopeId });
  const canViewUsers = can("read", { scopeType: "USER_ORG_SCOPE", scopeId: teamScopeId });

  // Workflows never appears here: it requires editTeamSettings, which already
  // routes to general first.
  const firstAccessiblePath: TeamSettingsPath | null = canEditTeamSettings
    ? "/settings/team-settings/general"
    : canViewUsers
      ? "/settings/team-settings/users"
      : null;

  return {
    isLoading,
    canEditTeamSettings,
    canViewUsers,
    hasAnyAccess: firstAccessiblePath !== null,
    firstAccessiblePath,
  };
}
